import { APP_ID, ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
  provideRouter,
  RouteReuseStrategy,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { proxyRoutes } from './shell.routes';
import { SharedStateModule, SmartEditRootModule } from '@boels/shared-state';
import { InterceptorsModule } from './interceptor/interceptors.module';
import { I18nRootModule } from './misc/i18n-root.module';
import { BoelsRouteReuseStrategy } from './misc/route-reuse-strategy';
import { SeoModule } from './seo/seo.module';
import {
  provideClientHydration,
  withNoHttpTransferCache,
} from '@angular/platform-browser';

export const sharedConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      proxyRoutes,
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
        urlUpdateStrategy: 'eager',
      }),
    ),
    importProvidersFrom(
      SharedStateModule,
      I18nRootModule,
      SeoModule,
      InterceptorsModule,
      SmartEditRootModule,
    ),
    { provide: APP_ID, useValue: 'serverApp' },
    {
      provide: RouteReuseStrategy,
      useClass: BoelsRouteReuseStrategy,
    },
    provideClientHydration(withNoHttpTransferCache()),
  ],
};
